





























































































































import { Component, Vue, Emit, Watch, Prop } from "vue-property-decorator";
import rest from "@/rest";
// components
// interfaces
import { namespace } from "vuex-class";
import { ExerciseVM } from "@/interfaces/ExerciseVM";
import { CourseElementVm, CustomTranslationType, QuizOptionVm } from "@/interfaces/CourseElementVm";
import { ParamDictionary } from "@/interfaces/ParamDictionary";
import { List } from "linq-collections";
import { CcPageVm } from "@/interfaces/CcPageVm";
import { CustomizationVm } from "@/interfaces/CustomizationVm";
import { ParamChoiceAiSuggestionVm } from "@/interfaces/ParamChoiceAiSuggestionVm";

const globals = namespace("globals");
const customization = namespace("customization");

@Component({
  components: {
  },
})
export default class MultipleChoiceElement extends Vue {
  @Prop() element!: CourseElementVm;

  @customization.Getter customizationSettings!: CustomizationVm;
  @globals.Getter selectedExercise!: ExerciseVM;
  @globals.Getter modulePages!: CcPageVm[];
  @globals.Getter selectedModulePage!: CcPageVm | null;
  @globals.Getter isMasterLanguageCode!: boolean;
  @globals.Action refreshSelectedBundle!: () => Promise<void>;

  isBusy = false;
  showMarkdownEditor = false;
  showEditDialog = false;
  editText = '';
  clipboardCopied = false;

  @Watch('showEditDialog')
  onShowEditDialogChanged(val: boolean): void {
    if (val) {
      this.$nextTick(() => {
        const ta = this.$refs.editTextarea as any;
        if (ta && ta.calculateInputHeight) {
          ta.calculateInputHeight();
        }
      });
    }
  }

  mounted() {}

  private addQuizOption(): void {
    // if (!this.selectedModulePage) return;
    // const element = this.selectedModulePage.courseElements!.find(el => el.id === elementId);
    // if (element && element.type === 'MultipleChoice') {
    //   };
    const newOptionId = Math.max(...this.element.options!.map(opt => opt.id)) + 1;
    this.element.options!.push({
      id: newOptionId,
      guid: this.$globalHelper.getNewGuid(),
      customTranslation: CustomTranslationType.Master,
      title: '',
      text: '',
      resolution: '',
      isRight: false,
      contentUrl: '',
      fillContainer: false,
      horizontalAlign: 'end',
      prompt: '',
      changePrompt: '',
      altText: '',
      imageLibrarySearchText: ''
    });
    this.element.guid = this.$globalHelper.getNewGuid(); // Forces L3RN online to ignore previous saved element states!
  }

  private removeQuizOption(elementId: number, optionId: number): void {
    // if (!this.selectedModulePage) return;
    // const element = this.selectedModulePage.courseElements!.find(el => el.id === elementId);
    // if (element && element.type === 'MultipleChoice') {
    // }
    this.element.options = this.element.options!.filter(option => option.id !== optionId);
    this.element.guid = this.$globalHelper.getNewGuid(); // Forces L3RN online to ignore previous saved element states!
  }

  private async copyEditTextToClipboard(): Promise<void> {
    try {
      await navigator.clipboard.writeText(this.editText);
      this.clipboardCopied = true;
      await this.$globalHelper.delay(2000);
      this.clipboardCopied = false;
    } catch (e) {
      console.error('Clipboard copy failed', e);
    }
  }

  /**
   * Opens the plain-text edit dialog and populates editText from the current element state.
   */
  private openEditDialog(): void {
    const lines: string[] = [];
    if (this.element.text && this.element.text.trim() !== '') {
      lines.push(this.element.text + '\n');
    }

    (this.element.options ?? []).forEach(opt => {
      if (opt.text && opt.text.trim() !== '') {
        lines.push((opt.text ?? '') + (opt.isRight ? '*' : ''));
      }
    });
    this.editText = lines.join('\n');
    this.showEditDialog = true;
  }

  /**
   * Parses editText and applies the result back to the element.
   * Format: first line = question, subsequent lines = options (trailing * = correct).
   */
  private applyEditText(): void {
    const lines = this.editText.split('\n');
    if (lines.length === 0) return;

    // First line is the question
    this.element.text = lines[0].trim();

    // Remaining non-empty lines are options
    const optionLines = lines.slice(1).filter(l => l.trim() !== '');
    const newOptions: QuizOptionVm[] = optionLines.map((line, index) => {
      const isRight = line.trimEnd().endsWith('*');
      const text = isRight ? line.trimEnd().slice(0, -1).trimEnd() : line.trim();
      // Reuse existing option ID if available, otherwise generate a new one
      const existingId = this.element.options && this.element.options[index]
        ? this.element.options[index].id
        : index + 1;
      return {
        id: existingId,
        guid: this.$globalHelper.getNewGuid(),
        customTranslation: CustomTranslationType.Master,
        text,
        isRight
      } as QuizOptionVm;
    });

    // Reassign sequential IDs
    newOptions.forEach((opt, i) => {
      opt.id = i + 1;
    });

    // console.log("Parsed options from edit text:", newOptions);

    this.element.options = newOptions;
    this.element.guid = this.$globalHelper.getNewGuid();
    this.showEditDialog = false;
    this.$forceUpdate();
  }

  private selectionChanged(): void {
    this.element.guid = this.$globalHelper.getNewGuid(); // Forces L3RN online to ignore previous saved element states!
  }

  private clearAndFocus(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!this.element) return;

    // Clear the textarea value
    this.element.text = '';
    // this.element.guid = this.$globalHelper.getNewGuid();

    // Focus the rendered textarea/input inside the v-textarea
    this.$nextTick(() => {
      const root = this.$el as HTMLElement;
      const textarea = root.querySelector('textarea') as HTMLTextAreaElement | null;
      if (textarea) {
        textarea.focus();
        return;
      }
      const input = root.querySelector('input') as HTMLInputElement | null;
      if (input) input.focus();
    });
  }

  // multiple choice
  async getAiSuggestion(): Promise<void> {
    this.isBusy = true;

    try {
      // let params: ParamDictionary = { dictionary: {}};
      // params.dictionary!["BundleId"] = this.selectedExercise.exBundleId!.toString();
      // params.dictionary!["ExerciseId"] = this.selectedExercise.id!.toString();
      // params.dictionary!["Question"] = this.element.text!;

      let knownAnswers = new List(this.element.options!)
        .where((o) => (o.text?.trim() ?? '') !== '')
        .select((o) => o.text)
        .toArray()
        .join(", ");

      let knownQuestions = new List(this.modulePages)
        .where((page) => page.id !== this.selectedModulePage!.id)
        .selectMany((page) => page.courseElements ?? [])
        .where((el) => el.type === "SingleChoice" || el.type === "MultipleChoice")
        .select((el) => el.text)
        .toArray()
        .join(", ");

      let params: ParamChoiceAiSuggestionVm = {
        page: this.selectedModulePage!,
        question: this.element.text || "",
        knownQuestions:  knownQuestions,
        knownAnswers: knownAnswers
      };

      const response = await rest.url("contentManager/getMultipleChoiceAiSuggestion").post(params);
      if (response) {
        console.log("AI response", response);
        // remove empty options
        this.element.options = this.element.options!.filter(option => (option.text?.trim() ?? '') !== '');

        // add new options
        if (response && Array.isArray(response)) {
          // Set the question text from the first option
          if (!this.element.text)
            this.element.text = response[0].question;

          response.forEach((option, index) => {
            this.element.options!.push({
              id: index + 1,
              guid: this.$globalHelper.getNewGuid(),
              customTranslation: CustomTranslationType.Master,
              title: '',
              text: option.text,
              resolution: option.resolution,
              isRight: option.isRight,
              contentUrl: '',
              fillContainer: false,
              horizontalAlign: 'end',
              prompt: '',
              changePrompt: '',
              altText: '',
              imageLibrarySearchText: ''
            });
          });

          // Update option ids
          this.element.options.forEach((option, index) => {
            option.id = index + 1;
          });
        }
        this.element.guid = this.$globalHelper.getNewGuid(); // Forces L3RN online to ignore previous saved element states!
      }
    } catch (error) {
      console.error("Error getting AI suggestions:", error);
    } finally {
      this.isBusy = false;
    }
  }

  // get compSettings() {
  //   return `{ enableZoom: ${this.element.enableZoom} }`;
  // }
}
